import classNames from 'classnames';
import React from 'react';

import * as selfStudiesPodcastStyles from './self-studies-podcast.module.css';

export function SelfStudiesPodcast({ styles }) {
	const backgroundColor = styles.backgroundColor;

	return (
		<div
			className={classNames(
				selfStudiesPodcastStyles.podcastEmbed,
				backgroundColor && backgroundColor,
				'fade-load'
			)}
		>
			<iframe
				allow='autoplay *; encrypted-media *; fullscreen *'
				title='podcast'
				sandbox='allow-forms allow-popups allow-same-origin allow-scripts allow-storage-access-by-user-activation allow-top-navigation-by-user-activation'
				src='https://embed.podcasts.apple.com/us/podcast/self-studies/id1565577089'
			/>
		</div>
	);
}
